<template>
  <div>
    <l-geo-json :geojson="geojsonData.geojson" :options="geojsonOptions" ref="geolayer" @ready="onLayerReady"></l-geo-json>
    <slot :currentItem="currentItem" :unit="value.metric" :min="min" :max="max"></slot>
  </div>
</template>
<script>

import {LGeoJson} from "@vue-leaflet/vue-leaflet"
import { getMin, getMax, normalizeValue, getColor, validNumber } from "./util"

function mouseover({ target }) {
  target.setStyle({
    weight: this.currentStrokeWidth,
    color: `#${this.currentStrokeColor}`,
    dashArray: ""
  })

  if (!L.Browser.ie && !L.Browser.opera) {
    target.bringToFront()
  }

  let geojsonItem = target.feature.properties
  let item = this.geojsonData.data.find(
    x => x[this.idKey] == geojsonItem[this.geojsonIdKey]
  )
  if (!item) {
    this.currentItem = { name: "", value: 0 }
    return
  }

  let tempItem = { name: item[this.titleKey], value: item[this.value.key] }
  if (this.extraValues) {
    let tempValues = []
    for (let x of this.extraValues) {
      tempValues.push({
        value: item[x.key],
        metric: x.metric
      })
    }
    tempItem = { ...tempItem, extraValues: tempValues }
  }
  this.currentItem = tempItem
}

function mouseout({ target }) {
  target.setStyle({
    weight: this.strokeWidth,
    color: `#${this.strokeColor}`,
    dashArray: ""
  })
  this.currentItem = { name: "", value: 0 }
}

export default {
  props: {
    geojson: Object,
    data: Array,
    center: Array,
    colorScale: Array,
    titleKey: String,
    idKey: String,
    value: Object,
    extraValues: Array,
    geojsonIdKey: String,
    mapStyle: Object,
    zoom: Number,
    mapOptions: Object,
    strokeColor: {type: String, default: 'fff'},
    currentStrokeColor: {type: String, default:'666'},
    strokeWidth: {type: Number, default: 2},
    currentStrokeWidth: {type: Number, default: 5}
  },
  mounted() {
    if (this.$parent._isMounted) {
      this.deferredMountedTo(this.$parent.mapObject)
    }
  },
  watch: {
    // Re-apply the choropleth style whenever the values change. @vue-leaflet
    // creates the geoJSON layer asynchronously (dynamic leaflet import), so on
    // first paint the features can be styled before `data`/min/max are settled
    // and fall back to Leaflet's default blue; without this they stayed blue
    // until an unrelated re-render (e.g. hover) rebuilt the layer. Re-styling
    // on data change (and on `ready` below) keeps the fill in sync.
    data: {
      deep: true,
      handler() {
        this.restyleLayer()
      }
    }
  },
  data() {
    return {
      geoLayer: null,
      currentItem: { name: "", value: 0 },
      geojsonOptions: {
        style: feature => {
          let itemGeoJSONID = feature.properties[this.geojsonIdKey]
          let color = "NONE"
          const {data} = this.geojsonData
          let item = data.find(x => x[this.idKey] == itemGeoJSONID)
          if (!item) {
            return {
              color: "white",
              weight: this.strokeWidth
            }
          }
          let valueParam = Number(item[this.value.key])
          if (!validNumber(valueParam)) {
            return {
              color: "white",
              weight: this.strokeWidth
            }
          }
          const { min, max } = this

          return {
            weight: this.strokeWidth,
            opacity: 1,
            color: `#${this.strokeColor}`,
            dashArray: "3",
            fillOpacity: 0.7,
            fillColor: getColor(valueParam, this.colorScale, min, max)
          }
        },
        onEachFeature: (feature, layer) => {
          layer.on({
            mouseover: mouseover.bind(this),
            mouseout: mouseout.bind(this)
          })
        }
      }
    }
  },
  computed: {
    min() {
      return getMin(this.geojsonData.data, this.value.key)
    },
    max() {
      return getMax(this.geojsonData.data, this.value.key)
    },
    geojsonData() {
      return {geojson: {...this.geojson}, data: this.data};
    }
  },
  components: {
    LGeoJson
  },
  methods: {
    onLayerReady(layer) {
      this.geoLayer = layer
      this.restyleLayer()
    },
    restyleLayer() {
      const layer = this.geoLayer
      if (layer && this.geojsonOptions.style) {
        layer.setStyle(this.geojsonOptions.style)
      }
    },
    deferredMountedTo(parent) {
      this.parent = parent
      for (var i = 0; i < this.$children.length; i++) {
        if (typeof this.$children[i].deferredMountedTo === "function") {
          this.$children[i].deferredMountedTo(parent)
        }
      }
    }
  }
}
</script>
